module.exports = __webpack_public_path__ + "static/img/alekseenko.fa8275b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/alekseenko.jpg
// module id = 456
// module chunks = 11